"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Settings = void 0;
var Settings = /** @class */ (function () {
    function Settings() {
        // tslint:disable:object-literal-key-quotes
        this.knowns = {
            "false": false,
            "null": null,
            "true": true,
        };
        this.unary = {
            "!": function (v) { return !v; },
            "+": function (v) { return +v; },
            "-": function (v) { return -1 * v; },
            // tslint:disable-next-line:no-bitwise
            "~": function (v) { return ~v; },
        };
        // tslint:disable:object-literal-sort-keys
        this.binary = {
            "&&": { precedence: 0, func: function (l, r) { return l && u(r); } },
            "||": { precedence: 0, func: function (l, r) { return l || u(r); } },
            // tslint:disable:no-bitwise
            "|": { precedence: 1, func: function (l, r) { return l | u(r); } },
            "^": { precedence: 1, func: function (l, r) { return l ^ u(r); } },
            "&": { precedence: 1, func: function (l, r) { return l & u(r); } },
            // tslint:enable:no-bitwise
            "===": { precedence: 2, func: function (l, r) { return l === u(r); } },
            "!==": { precedence: 2, func: function (l, r) { return l !== u(r); } },
            // tslint:disable-next-line:triple-equals
            "==": { precedence: 2, func: function (l, r) { return l == u(r); } },
            // tslint:disable-next-line:triple-equals
            "!=": { precedence: 2, func: function (l, r) { return l != u(r); } },
            // tslint:disable:no-bitwise
            "<<": { precedence: 3, func: function (l, r) { return l << u(r); } },
            ">>>": { precedence: 3, func: function (l, r) { return l >>> u(r); } },
            ">>": { precedence: 3, func: function (l, r) { return l >> u(r); } },
            // tslint:enable:no-bitwise
            "<=": { precedence: 4, func: function (l, r) { return l <= u(r); } },
            ">=": { precedence: 4, func: function (l, r) { return l >= u(r); } },
            "<": { precedence: 4, func: function (l, r) { return l < u(r); } },
            ">": { precedence: 4, func: function (l, r) { return l > u(r); } },
            "+": { precedence: 5, func: function (l, r) { return l + u(r); } },
            "-": { precedence: 5, func: function (l, r) { return l - u(r); } },
            "*": { precedence: 6, func: function (l, r) { return l * u(r); } },
            "/": { precedence: 6, func: function (l, r) { return l / u(r); } },
            "%": { precedence: 6, func: function (l, r) { return l % u(r); } },
        };
    }
    Object.defineProperty(Settings.prototype, "knownIdentifiers", {
        // tslint:enable:object-literal-sort-keys
        get: function () {
            return Object.getOwnPropertyNames(this.knowns);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Settings.prototype, "unaryOperators", {
        get: function () {
            return Object.getOwnPropertyNames(this.unary);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Settings.prototype, "binaryOperators", {
        get: function () {
            return Object.getOwnPropertyNames(this.binary).sort(function (b1, b2) { return b2.length - b1.length; });
        },
        enumerable: false,
        configurable: true
    });
    Settings.prototype.addKnownValue = function (identifier, value) {
        this.knowns[identifier] = value;
        return this;
    };
    Settings.prototype.containsKnown = function (identifier) {
        return identifier in this.knowns;
    };
    Settings.prototype.getKnownValue = function (identifier) {
        return this.knowns[identifier];
    };
    Settings.prototype.addUnaryOperator = function (op, func) {
        this.unary[op] = func;
        return this;
    };
    Settings.prototype.containsUnary = function (op) {
        return this.unary[op] != null;
    };
    Settings.prototype.getUnaryOperator = function (op) {
        return this.unary[op];
    };
    Settings.prototype.addBinaryOperator = function (op, func, precedence) {
        if (precedence === void 0) { precedence = 7; }
        this.binary[op] = { precedence: precedence, func: func };
        return this;
    };
    Settings.prototype.containsBinary = function (op) {
        return this.binary[op] != null;
    };
    Settings.prototype.getBinaryOperator = function (op) {
        return this.binary[op];
    };
    Settings.default = new Settings();
    return Settings;
}());
exports.Settings = Settings;
function u(v) {
    return typeof v === "function" ? v() : v;
}
//# sourceMappingURL=Settings.js.map